export const HashZero = "0x0000000000000000000000000000000000000000000000000000000000000000";
//# sourceMappingURL=hashes.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ethersproject/constants/lib.esm/hashes.js
// module id = 1066
// module chunks = 0